import { useWindowSize } from "@vueuse/core";
import { computed, ref } from "vue";
import type { RouteLocationNormalizedGeneric } from "vue-router";

const isPdf = ref<boolean>(false);

export const usePdf = () => {
	const { width } = useWindowSize();

	const isDesktop = computed(() => isPdf.value);
	const shouldUseDragScroll = computed(() => isDesktop.value && width.value > 1024);

	const syncWithRoute = (to: RouteLocationNormalizedGeneric) => {
		isPdf.value = to.query?.mode === "pdf";
	};

	return { isDesktop, shouldUseDragScroll, syncWithRoute };
};
